const createUniqueIdentifier = (product) => {
    return `${product.id}_w${product.size.width}_h${product.size.height}_${product.frame.id}_${product.passpartout}`;
};
export default createUniqueIdentifier;